import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const MusicIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <path
        fill={fill}
        d="M30 0h2v23c0 2.761-3.134 5-7 5s-7-2.239-7-5c0-2.761 3.134-5 7-5 1.959 0 3.729 0.575 5 1.501v-11.501l-16 3.556v15.444c0 2.761-3.134 5-7 5s-7-2.239-7-5c0-2.761 3.134-5 7-5 1.959 0 3.729 0.575 5 1.501v-19.501l18-4z"
      />
    </Icon>
  );
};

MusicIcon.propTypes = {
  fill: PropTypes.string,
};

export default MusicIcon;
